import React, {useEffect, useState} from 'react'
import 'react-datepicker/dist/react-datepicker.css'
import {useSolv} from "./components/SolvProvider"
import {useIntlEx} from "./components/IntlUtils"
import {closeDialog, ModalDialog} from "./components/DialogUtils";
import {PurchaseCreditsControls} from "./components/CreditTransactionUtils";
import getLogger from "./components/Logging.js"
import './App.css'

const log = getLogger("CreditTransactionTopupDialog")

export default function CreditTransactionTopupDialog(props)  {

  const {api, env} = useSolv()

  const {intl} = useIntlEx()

  const [touched, setTouched] = useState(false)
  const [alert, setAlert] = useState(null)

  const [minimumCredits, setMinimumCredits] = useState(0.0)
  const [tenant, setTenant] = useState(null)
  const [usdMultiplier, setUsdMultiplier] = useState(null)
  const [currencyCode, setCurrencyCode] = useState(null)
  const [description, setDescription] = useState(`${intl.msg("credit_transaction_description_bonus")} `)

  const [dialogSize, setDialogSize] = useState("md")

  useEffect(() => {
    if (props.tenant) {
      // log.debug("useEffect: tenant=", props.tenant)
      setTenant(props.tenant)
    }
  }, [props.tenant])

  useEffect(() => {
    if (tenant) {
      api.getCurrency(tenant.currencyCode)
        .then(({data}) => {
          setUsdMultiplier(data.usdMultiplier)
          setCurrencyCode(data.currencyCode)
          const minCredits = Math.ceil(10.00 / data.usdMultiplier)
          setMinimumCredits(minCredits)
        })
    }
  }, [tenant])

  function handleOpenDialog() {
  }

  function handleCloseDialog() {
    closeDialog("dlg_credits_add")
  }

  function handleSuccess(res) {
    window.location.reload()
  }

  function handleFailure(alert) {
    setAlert(alert)
  }

  return (

    tenant &&
      <>
        <ModalDialog
          dialogId="dlg_credits_add"
          size={dialogSize}
          keyboard={"true"}
          backdrop={props.backdrop || "static"}
          onOpen={handleOpenDialog}
          onClose={handleCloseDialog}>

          <ModalDialog.Header
            title={intl.msg("credits_add_title")}
            description={intl.msg("credits_add_subtitle")}
            alert={alert}
          />

          <ModalDialog.Body>

            <PurchaseCreditsControls
              tenant={tenant}
              paymentInfo={{
                minimumCredits: minimumCredits,
                currencyCode: currencyCode || "USD",
                usdMultiplier: usdMultiplier,
                description: intl.msg("credit_transaction_description_purchase"),
              }}
              options={{
                offlinePayment: true,
              }}
              onSuccess={handleSuccess}
              onFailure={handleFailure}
            />

          </ModalDialog.Body>

        </ModalDialog>

      </>
    )
  }